const isSearchTextValid = (searchText: string): boolean => /.{3,}/i.test(searchText.trim());

export default isSearchTextValid;
